import axios from 'axios';
import apiConfig from '../../api.config';

export default function getPaperlessUserHotels({oldUUID, newUUID}) {
  const {
    host,
    URIs: { updateDeviceName },
  } = apiConfig;

  const data = {
    oldUUID,
    newUUID,
  };

  const uri = `${host}${updateDeviceName}`;

  return axios.put(uri, data).then(res => res.data);
}
